export const BaseActionTrigger = {
  INIT: '__impage_action_trigger_init',
  CLICK: '__impage_action_trigger_click',
  MOUSE_ENTER: '__impage_action_trigger_mouseEnter',
  MOUSE_LEAVE: '__impage_action_trigger_mouseLeave',
  DOUBLE_CLICK: '__impage_action_trigger_double_click',
  LONG_PRESS: '__impage_action_trigger_long_press',
  ENTER_VIEW: '__impage_action_trigger_enter_view',
  LEAVE_VIEW: '__impage_action_trigger_leave_view',
};

export const ComponentEventListenerTypes = {
  INIT: 'afterRender',
  CLICK: 'click',
  MOUSE_ENTER: 'mouseEnter',
  MOUSE_LEAVE: 'mouseLeave',
  DOUBLE_CLICK: 'doubleClick',
  LONG_PRESS: 'longPress',
  ENTER_VIEW: 'enterView',
  LEAVE_VIEW: 'leaveView',
};

export const HotAreaEventListenerTypes = ComponentEventListenerTypes;
